document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".card-countdown, #countdown-timer").forEach(function (timerDiv) {
    const endTime = new Date(timerDiv.dataset.timer).getTime();

    function updateCountdown() {
      const now = new Date().getTime();
      const diff = endTime - now;

      if (diff <= 0) {
        timerDiv.innerHTML = "Expired";
        timerDiv.classList.remove("loading");
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      timerDiv.innerHTML =
        days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
      timerDiv.classList.remove("loading");
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
});